import { LotteriesCategoryPageQuery } from 'lib/datoCms/queries/getAllLotteriesCategoryPage';

/* eslint-disable no-unused-vars */
export enum Suppliers {
  Sisal = 'sisal',
  GrattaVinci = 'grattaevinci',
  Lottomatica = 'lottomatica',
  LotteriaItalia = 'lotteriaItalia',
}
/* eslint-enable no-unused-vars */

/* eslint-disable no-unused-vars */
export enum SuppliersGame {
  GrattaVinci = 'GrattaeVinci',
  LotteriItalia = 'LotteriaItalia',
}
/* eslint-enable no-unused-vars */

export type PageContentProps = {
  lotteriesPageCategory: LotteriesCategoryPageQuery['allLotteriesCategoryPages'];
};
